import { apiGet } from 'helpers/ApiHelper';
import { toDate, objectToQuery } from 'helpers/Formatter';
import Auth from 'j-toker';
import { deepDiver } from 'helpers/utilities';
import { apiPostMultipart } from 'helpers/ApiHelper';

import * as dashboardActions from './dashboardActions';
import * as notificationsActions from './notificationActions';

export function getTenantMaintenanceRequest() {
  return dispatch => {
    dispatch({ type: 'LOAD_MAINTENANCE_TICKETS' });

    return dispatch({
      payload: apiGet(Auth.getApiUrl() + '/leads/maintenance_tickets')
        .done(response => {
          dispatch(saveMaintenanceTickets(response.maintenance_tickets));
        })
        .catch(error => {
          console.error('request failed', error);
        }),
    });
  };
}

export function getTenantMaintenanceRequestPendingSync(blankTicketNumbers) {
  return (dispatch, getState) => {
    let { tickets, ticket } = getState().tenantMaintenance;
    const options = {
      ticket_ids: blankTicketNumbers,
    };

    return dispatch({
      payload: apiGet(
        Auth.getApiUrl() + '/leads/tenant_maintenance_tickets_pending_sync' + objectToQuery(options)
      )
        .done(response => {
          if (response.maintenance_tickets && response.maintenance_tickets.length > 0) {
            tickets = tickets.map(existingTicket => {
              if (
                !existingTicket.ticket_number &&
                response.maintenance_tickets.some(
                  responseTicket => responseTicket.id === existingTicket.id
                )
              ) {
                existingTicket.ticket_number = response.maintenance_tickets.find(
                  responseTicket => responseTicket.id === existingTicket.id
                )['ticket_number'];
              }
              return existingTicket;
            });
            dispatch(saveMaintenanceTickets(tickets));

            if (
              ticket &&
              response.maintenance_tickets.some(responseTicket => responseTicket.id === ticket.id)
            ) {
              ticket.ticket_number = response.maintenance_tickets.find(
                responseTicket => responseTicket.id === ticket.id
              )['ticket_number'];

              dispatch(saveMaintenanceTicket(ticket));
            }
          }
        })
        .catch(error => {
          console.error('request failed', error);
        }),
    });
  };
}

export function getTenantMaintenanceRooms() {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + '/leads/rooms')
        .done(response => {
          dispatch(saveMaintenanceRooms(response.maintenance_rooms));
        })
        .catch(error => {
          console.error('request failed', error);
        }),
    });
  };
}

function saveMaintenanceRooms(rooms) {
  rooms.unshift({ label: 'None', value: 'None' });

  return {
    type: 'SAVE_MAINTENANCE_ROOMS',
    rooms,
  };
}

function saveMaintenanceTickets(responseTickets) {
  let tickets = responseTickets.map(ticket => {
    if (ticket.scheduled_at) {
      ticket.scheduled_at = toDate(ticket.scheduled_at);
    }
    return {
      ...ticket,
    };
  });
  return {
    type: 'SAVE_MAINTENANCE_TICKETS',
    tickets,
  };
}

export function createTenantMaintenanceRequest(data) {
  let data_clone = JSON.parse(JSON.stringify(data));
  const multiPartFormData = new FormData();

  if (deepDiver(data, 'files.0.lastModified')) {
    for (var i = 0; i < data['files'].length; i++) {
      multiPartFormData.append(`file_${i}`, data['files'][i]);
    }
  }

  if (data['room']) {
    data_clone['room_id'] = data['room']['value'];
  }
  delete data_clone['room'];

  multiPartFormData.append('data', JSON.stringify(data_clone));

  return dispatch => {
    return dispatch({
      payload: apiPostMultipart(
        Auth.getApiUrl() + '/landlords/tenant_maintenance_tickets',
        multiPartFormData
      )
        .then(response => {
          dispatch(notificationsActions.showSuccess('ticketSuccessfullyCreated'));
          dispatch(getTenantMaintenanceRequest());
          dispatch(dashboardActions.closeMaintenanceDialog());
          return response;
        })
        .catch(error => {
          dispatch(notificationsActions.showFailure(error));
          dispatch(notificationsActions.hideLoader());
        }),
    });
  };
}

export function saveMaintenanceTicket(ticket) {
  return {
    type: 'SAVE_MAINTENANCE_TICKET',
    ticket,
  };
}

export function getMaintenanceTicket(ticketId) {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/leads/maintenance_tickets/${ticketId}`)
        .done(response => {
          dispatch(saveMaintenanceTicket(response.maintenance_ticket));
        })
        .catch((error, textStatus) => {
          dispatch(notificationsActions.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}
